import styled, { css } from 'styled-components';

import { FitFeedbackProvider } from 'productTemplate/providers/FitFeedbackProvider';
import Footer from 'layout/footer/components/Footer';
import { ProductInfo } from 'productTemplate/components/footer/ProductInfo';
import { ProductTemplateDesktopFooterLinks } from 'productTemplate/components/footer/ProductTemplateDesktopFooterLinks';
import { BigBuyBarDesktop } from 'productTemplate/components/buyBar/BigBuyBarDesktop';
import { BigBuyBarDesktopViewStateProvider } from 'productTemplate/providers/BigBuyBarDesktopViewStateProvider';
import { BuyBarDesktopOpenWindows } from 'productTemplate/components/buyBar/BuyBarDesktopOpenWindows';
import { ProductUnavailableInRegion } from './ProductUnavailableInRegion';

interface IProductTemplateDesktopFooterUpdatedProps {
  isAvailabilityRestricted: boolean;
  isFooterExpanded: boolean;
  setIsFooterExpanded: (val: boolean) => void;
  isFetchingBuyBarData?: boolean;
}

export const ProductTemplateDesktopFooterUpdated = ({
  isAvailabilityRestricted,
  isFooterExpanded,
  setIsFooterExpanded,
  isFetchingBuyBarData,
}: IProductTemplateDesktopFooterUpdatedProps) => {
  return (
    <ProductTemplateDesktopFooterUpdated.Footer $isFooterExpanded={isFooterExpanded}>
      <ProductTemplateDesktopFooterUpdated.FooterTop>
        <ProductInfo />
        {isAvailabilityRestricted ? (
          <ProductUnavailableInRegion />
        ) : (
          <>
            <BuyBarDesktopOpenWindows />
            <BigBuyBarDesktopViewStateProvider>
              <BigBuyBarDesktop isFetchingBuyBarData={isFetchingBuyBarData} />
            </BigBuyBarDesktopViewStateProvider>
          </>
        )}
        <FitFeedbackProvider>
          <ProductTemplateDesktopFooterLinks
            isFooterExpanded={isFooterExpanded}
            setIsFooterExpanded={setIsFooterExpanded}
          />
        </FitFeedbackProvider>
      </ProductTemplateDesktopFooterUpdated.FooterTop>
      <ProductTemplateDesktopFooterUpdated.FooterBottom>
        <Footer />
      </ProductTemplateDesktopFooterUpdated.FooterBottom>
    </ProductTemplateDesktopFooterUpdated.Footer>
  );
};

ProductTemplateDesktopFooterUpdated.Footer = styled.footer<{ $isFooterExpanded?: boolean }>`
  position: fixed;
  width: 100%;
  bottom: 0;
  height: 225px;
  transition: transform 0.3s ease-in-out;
  transform: translateY(145px);
  pointer-events: auto;
  background-color: #fff;
  z-index: ${({ theme }) => theme.zIndex.pdpFooter};

  ${({ $isFooterExpanded }) =>
    $isFooterExpanded &&
    css`
      transform: translateY(0);
    `}
`;

ProductTemplateDesktopFooterUpdated.FooterTop = styled.div`
  display: flex;
  justify-content: space-between;
  height: 75px;
`;

// Edit: height 100% to persist height and width of the footer in case of absolute positioned children
ProductTemplateDesktopFooterUpdated.FooterBottom = styled.div`
  height: 100%;
  width: 100%;
  background: ${({ theme }) => theme.colors.white};
  > footer {
    margin: 0;
    width: 100vw;
    padding: 8px 32px 24px;
    position: absolute;
  }
  > footer > div {
    min-height: unset;
  }
`;
